import React, { Component } from "react";
import ReactGA from "react-ga";
import { deploymentEnvironment, customLog } from "../../variables/Variables";
import { Link, withRouter } from "react-router-dom";
import { FormGroup, FormControl, Button } from "react-bootstrap";
import * as routes from "../../routes/app";
// Form CSS
import "../../assets/css/form.css";
// Firebase
import firebase, {
  auth,
  doCreateUserWithEmailPassword,
  getUserIdFromEmail,
  fire,
} from "../../firebase/index";

// //FormInput types
// const formStyle = {
//   border: "5px solid #B0B0B0",
//   borderRadius: "10px",
//   width: "100%",
//   // height: '5.5em',
//   fontSize: "1.7em"
//   /*padding: "25px 20px"*/
// };
// const buttonStyle = {
//   backgroundColor: "#3C3E41",
//   borderColor: "#3C3E41",
//   color: "white",
//   width: "500px",
//   borderRadius: "40px",
//   fontSize: "2.3em"
//   // boxShadow: "1px 3px 10px #B0B0B0"
// };

var trackerID = "";
if (deploymentEnvironment) {
  //! Live
  trackerID = "G-7D4M74VB11";
} else {
  //! Test
  trackerID = "G-LWK1V2E1FE";
}

const SignUpPage = ({ history }) => (
  <div>
    <SignupForm history={history} />
  </div>
);

const INITIAl_STATE = {
  username: "",
  useremail: "",
  companyName: "",
  password: "",
  confirmPassword: "",
  error: null,
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.pushUserObjectToFirebase = this.pushUserObjectToFirebase.bind(this);
    this.handleLoginLink = this.handleLoginLink.bind(this);
    this.state = {
      ...INITIAl_STATE,
      isLoading: false,
    };
  }

  addUserDatabase() {
    firebase
      .database()
      .ref("registeredUsersOnPlatform")
      .child(auth.currentUser.uid)
      .set(auth.currentUser.email);

    //OLD CODE
    // firebase.database().ref('registeredUsersOnPlatform/' + auth.currentUser.uid).set({
    //     email: auth.currentUser.email,
    //     name: username
    // })
  }

  //FINISH THIS FUNCTION LATER
  pushUserObjectToFirebase() {
    var user = fire.auth().currentUser;

    user
      .updateProfile({
        displayName: this.state.username,
      })
      .catch(function(error) {
        customLog(error.message);
      });

    var newUserData = {
      name: this.state.username,
      company: this.state.companyName,
      email: auth.currentUser.email,
      isAdmin: true,
      isPaidUser: true,
      lastLoggedInPlatform: "Web-Dashboard",
      lastSeenLocation: "",
      lastSeenTime: new Date() / 1000,
      numberOfLocksInAccount: 0,
      numberOfTotalLockUnlocks: 0,
      numberOfUsersSharedTo: 0,
      registeredOn: new Date() / 1000,
      shareCreditsRemaining: 200,
      uid: auth.currentUser.uid,
    };

    var newUserSetting = {
      isTutorialCompleted: false,
      language: "en",
    };

    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .set(newUserData);

    fire
      .database()
      .ref("userSettings")
      .child(auth.currentUser.uid)
      .set(newUserSetting);
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });
    const {
      username,
      useremail,
      password,
      confirmPassword,
      companyName,
    } = this.state;
    const { history } = this.props;

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Validate fields
    if (!username) {
      this.setState({ error: "Username is required", isLoading: false });
      return;
    }
    if (!useremail) {
      this.setState({ error: "Email is required", isLoading: false });
      return;
    }
    if (!emailRegex.test(useremail)) {
      this.setState({ error: "Enter a valid email address", isLoading: false });
      return;
    }
    if (!password) {
      this.setState({ error: "Password is required", isLoading: false });
      return;
    }
    if (password.length < 6) {
      this.setState({
        error: "Password must be at least 6 characters long",
        isLoading: false,
      });
      return;
    }
    if (!confirmPassword) {
      this.setState({
        error: "Confirm password is required",
        isLoading: false,
      });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({ error: "Passwords do not match", isLoading: false });
      return;
    }

    firebase
      .auth()
      .fetchProvidersForEmail(useremail)
      .then((providers) => {
        if (providers.length > 0) {
          this.setState({ error: "Email already exists", isLoading: false });
          return;
        } else {
          doCreateUserWithEmailPassword(useremail, password)
            .then((authUser) => {
              this.setState(() => ({
                ...INITIAl_STATE,
                companyName: companyName,
                username: username,
              }));
              this.addUserDatabase(username, useremail);
              this.pushUserObjectToFirebase();

              const dataToPost = {
                name: username,
                email: useremail,
              };

              fetch(
                "https://us-central1-egeetouchindustrial.cloudfunctions.net/signUpEmail",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(dataToPost),
                }
              );
            })

            .then(() => {
              this.setState({ isLoading: false });
              history.push(routes.PlanSubscription);
            })
            .catch((error) => {
              this.setState(byPropKey("error", error));
              this.setState({ isLoading: false });
            });
        }
      })
      .catch((error) => {
        console.error("Error checking email:", error);
      });

    event.preventDefault();
  };

  handleLoginLink(e) {
    e.preventDefault();
    window.location.href = "/Log In";
  }

  render() {
    const {
      username,
      companyName,
      useremail,
      password,
      confirmPassword,
      error,
    } = this.state;

    return (
      <div
        className="Login"
        //  style={{ marginTop: "160px" }}
      >
        <form onSubmit={this.onSubmit}>
          <h1
            style={{
              marginBottom: "70px",
              marginTop: "10px",
              // lineHeight: "10px",
              alignContent: "center",
            }}
          >
            Sign Up
          </h1>
          <FormGroup>
            {/* <ControlLabel>Name</ControlLabel> */}
            <div className="formcontrols">
              <FormControl
                // className="signupform"
                // style={formStyle}
                value={username}
                className={"inputText"}
                placeholder="Your Name"
                onChange={(event) =>
                  this.setState(byPropKey("username", event.target.value))
                }
                type="text"
              />
              <br />
              {/* <ControlLabel>Company Name</ControlLabel> */}

              <FormControl
                // style={formStyle}
                value={companyName}
                className={"inputText"}
                placeholder="Your Company Name"
                onChange={(event) =>
                  this.setState(byPropKey("companyName", event.target.value))
                }
                type="text"
              />
              <br />
              {/* <ControlLabel>Email Address</ControlLabel> */}

              <FormControl
                // style={formStyle}
                value={useremail}
                className={"inputText"}
                placeholder="Your Email"
                onChange={(event) =>
                  this.setState(byPropKey("useremail", event.target.value))
                }
                type="email"
              />
              <br />
              {/* <ControlLabel>Password</ControlLabel> */}

              <FormControl
                // style={formStyle}
                className={"inputText"}
                value={password}
                placeholder="Password"
                onChange={(event) =>
                  this.setState(byPropKey("password", event.target.value))
                }
                type="password"
              />
              <br />
              {/* <ControlLabel>Confirm Password</ControlLabel> */}

              <FormControl
                // style={formStyle}
                value={confirmPassword}
                className={"inputText"}
                placeholder="Confirm Password"
                onChange={(event) =>
                  this.setState(
                    byPropKey("confirmPassword", event.target.value)
                  )
                }
                type="password"
              />
            </div>
          </FormGroup>

          <h4 style={{ textAlign: "center", fontSize: "16px" }}>
            {"By signing up, you agree to our "}
            <a
              href="#"
              onClick={() => {
                window.open(
                  "https://www.egeetouch.com/terms-conditions",
                  "_blank"
                );
              }}
            >
              {" Terms of Service "}
            </a>
            {" and "}
            <a
              href="#"
              onClick={() => {
                window.open(
                  "https://www.egeetouch.com/privacy-policy",
                  "_blank"
                );
              }}
            >
              {" Privacy Policy "}
            </a>
          </h4>

          {/* Display error message */}
          {error && (
            <p style={{ color: "red", textAlign: "center" }}>{error}</p>
          )}
          <Button
            className="loginsignupbutton"
            disabled={this.state.isLoading}
            onClick={() => {
              ReactGA.event(
                {
                  category: "register",
                  action: "form submission",
                  value: 1,
                },
                [trackerID]
              );
            }}
            // style={buttonStyle}
            type="submit"
          >
            {this.state.isLoading ? "Loading..." : "Sign Up"}
          </Button>

          {/* <Link id="gotoSignUp" to="/login">
            Login
          </Link> */}

          {error && <p>{error.message}</p>}
          <br />
          <h4 style={{ textAlign: "center" }}>
            {"Already have an account? "}
            <a href="#" onClick={this.handleLoginLink}>
              Log In
            </a>
          </h4>
        </form>
      </div>
    );
  }
}

export default withRouter(SignupForm);

export { SignUpPage };
